import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import ITSupportAdminPage from "../itsupport/ITSupportAdminPage";

export default function AdminITSupportPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <AdminNavbar />
      <ITSupportAdminPage />
    </div>
  );
}
